import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlDecoder'
})
export class UrlDecoderPipe implements PipeTransform {

  transform(value: string): string {

    const newLineRegex = new RegExp(/\n/g);
    const fowardSlashRegex = new RegExp(/%2[Ff]/g);
    const commaRegex = new RegExp(/%2[Cc]/g);

    const decodedString = decodeURI(value);

    let replacedString = decodedString.replace(newLineRegex, '<br/>');
    replacedString = replacedString.replace(fowardSlashRegex, "/");  
    replacedString = replacedString.replace(commaRegex, ",");  

    return replacedString;

  }
  

}
